var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "e-filters",
        {
          ref: "filters",
          attrs: { searching: _vm.fetching },
          on: { search: _vm.filterData, reset: _vm.resetFiltersLocal },
          scopedSlots: _vm._u([
            {
              key: "after_buttons",
              fn: function () {
                return [
                  _c("e-button", {
                    staticClass: "ml-1 btn-sm-block",
                    attrs: {
                      id: "installment-sale-download",
                      variant: "primary",
                      icon: "download",
                      busy: _vm.downloading,
                      text: _vm.$t("Baixar Relatório"),
                    },
                    on: { click: _vm.downloadReport },
                  }),
                  _c("a", {
                    ref: "downloadLink",
                    staticStyle: { display: "none" },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "div",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("e-store-combo", {
                        attrs: {
                          id: "installment-sale-store_id",
                          required: false,
                        },
                        model: {
                          value: _vm.filters.storeId,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "storeId", $$v)
                          },
                          expression: "filters.storeId",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "installment-sale-period",
                          type: "date-range-picker",
                          label: _vm.$t("Período da venda"),
                        },
                        model: {
                          value: _vm.filters.rangeDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "rangeDate", $$v)
                          },
                          expression: "filters.rangeDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "installment-sale-channel",
                          type: "vue-select",
                          label: _vm.$t("Canal"),
                          placeholder: _vm.$t("Todos"),
                          options: _vm.paymentChannelOptions,
                        },
                        model: {
                          value: _vm.filters.paymentChannel,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "paymentChannel", $$v)
                          },
                          expression: "filters.paymentChannel",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "3" } },
                    [
                      _c("FormulateInput", {
                        attrs: {
                          id: "installment-sale-card_brand",
                          type: "text",
                          label: _vm.$t("Bandeira"),
                        },
                        model: {
                          value: _vm.filters.cardBrand,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "cardBrand", $$v)
                          },
                          expression: "filters.cardBrand",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
      _vm.summary
        ? _c(
            "b-card-actions",
            { attrs: { "no-actions": "", title: _vm.$t("Resumo do período") } },
            [
              _c(
                "b-row",
                _vm._l(_vm.summaryCards, function (card) {
                  return _c(
                    "b-col",
                    {
                      key: card.label,
                      staticClass: "mb-1",
                      attrs: { md: "3" },
                    },
                    [
                      _c("div", { staticClass: "summary-card" }, [
                        _c("p", { staticClass: "mb-0 text-muted" }, [
                          _vm._v(" " + _vm._s(card.label) + " "),
                        ]),
                        _c(
                          "p",
                          { staticClass: "h4 mb-0", class: card.variant },
                          [_vm._v(" " + _vm._s(card.value) + " ")]
                        ),
                      ]),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-card-actions",
        {
          attrs: { "action-refresh": "", "show-loading": _vm.fetching },
          on: { refresh: _vm.getData },
        },
        [
          _c(
            "div",
            { attrs: { slot: "title" }, slot: "title" },
            [
              _c("e-page-size-selector", {
                attrs: { "per-page": _vm.paging.pageSize },
                on: { change: _vm.pageSizeChange },
              }),
            ],
            1
          ),
          _c("b-table", {
            staticClass: "bordered",
            attrs: {
              id: "installment-sale-table",
              "show-empty": "",
              responsive: "",
              striped: "",
              small: "",
              "empty-text": _vm.queryExecuted
                ? _vm.$t(
                    "Nenhuma venda parcelada encontrada para o filtro informado."
                  )
                : _vm.$t("Informe os filtros e clique em Pesquisar."),
              fields: _vm.fields,
              items: _vm.results,
            },
            scopedSlots: _vm._u([
              {
                key: "cell(divergence)",
                fn: function (row) {
                  return [
                    _vm.hasDivergence(row.item)
                      ? _c("b-badge", { attrs: { variant: "light-danger" } }, [
                          _vm._v(
                            " " + _vm._s(row.item.policyDivergenceDetail) + " "
                          ),
                        ])
                      : _c("span", [_vm._v("-")]),
                  ]
                },
              },
            ]),
          }),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("e-pagination-summary", {
                    attrs: {
                      "current-page": _vm.paging.currentPage,
                      "per-page": _vm.paging.pageSize,
                      total: _vm.paging.rowCount,
                      "total-on-page": _vm.paging.rowsInCurrentPage,
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { cols: "6" } },
                [
                  _c("b-pagination", {
                    attrs: {
                      align: "right",
                      "total-rows": _vm.paging.rowCount,
                      "per-page": _vm.paging.pageSize,
                      "aria-controls": "installment-sale-table",
                    },
                    on: { change: _vm.pageChange },
                    model: {
                      value: _vm.paging.currentPage,
                      callback: function ($$v) {
                        _vm.$set(_vm.paging, "currentPage", $$v)
                      },
                      expression: "paging.currentPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }